import { render, staticRenderFns } from "./InventoryItemFields.vue?vue&type=template&id=b5038f50"
import script from "./InventoryItemFields.vue?vue&type=script&lang=js"
export * from "./InventoryItemFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports